import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import { reducer as toastrReducer } from 'react-redux-toastr';

import AuthReducer from '../auth/authReducer';
import DashboardReducer from '../dashboard/dashboardReducer';
import TabReducer from '../common/tab/tabReducer';
import UsuarioPerfilReducer from '../usuarioPerfil/usuarioPerfilReducer';
import UsuarioReducer from '../usuario/usuarioReducer';
import CidadeReducer from '../cidade/cidadeReducer';
import EmpresaReducer from '../empresa/empresaReducer';
import FornecedorReducer from '../fornecedor/fornecedorReducer';
import VeiculoReducer from '../veiculo/veiculoReducer';
import UnidadeMedidaReducer from '../unidadeMedida/unidadeMedidaReducer';
import ProdutoReducer from '../produto/produtoReducer';
import ClienteReducer from '../cliente/clienteReducer';
import ClienteAreaReducer from '../clienteArea/clienteAreaReducer';
import AnalisePrecoReducer from '../analisePreco/analisePrecoReducer';
import PlanoContaReducer from '../planoConta/planoContaReducer';
import CentroCustoReducer from '../centroCusto/centroCustoReducer';
import ColetaReducer from '../coleta/coletaReducer';
import AplicacaoReducer from '../aplicacao/aplicacaoReducer';
import AbastecimentoReducer from '../abastecimento/abastecimentoReducer';
import AgendaReducer from '../agenda/agendaReducer';

const rootReducer = combineReducers({
	auth: AuthReducer,
	dashboard: DashboardReducer,
	usuarioPerfil: UsuarioPerfilReducer,
	usuario: UsuarioReducer,
	empresa: EmpresaReducer,
	cidade: CidadeReducer,
	fornecedor: FornecedorReducer,
	veiculo: VeiculoReducer,
	unidadeMedida: UnidadeMedidaReducer,
	produto: ProdutoReducer,
	cliente: ClienteReducer,
	clienteArea: ClienteAreaReducer,
	analisePreco: AnalisePrecoReducer,
	planoConta: PlanoContaReducer,
	centroCusto: CentroCustoReducer,
	coleta: ColetaReducer,
	aplicacao: AplicacaoReducer,
	abastecimento: AbastecimentoReducer,
	agenda: AgendaReducer,
    tab: TabReducer,
    form: formReducer,
    toastr: toastrReducer
});

export default rootReducer;
